<template>
<modal :show="show" @close="close">
	<Loader :loading="loading" ref="loader"></Loader>
    <div class="modal-header border-0">
        <h5 class="modal-title">SOS Download</h5>
        <button @click="close" type="button" class="close btn btn-round">
            <i class="icon icon-close"></i>
        </button>
    </div>

    <div class="modal-body p-4 overflow-auto">
		<label>Enter your email for a download link</label>
        <input @keydown.enter="confirm" v-model="email">
    </div>

    <div class="modal-footer border-0">
        <button @click="close">
            cancel
        </button>
        <button class="confirm-button" @click="confirm">
            confirm
        </button>
    </div>
</modal>
</template>

<script>
import Modal from "@/../submodules/vue-base/components/Modal";
import Loader from "@/../submodules/vue-base/components/Loader";
import axios from "axios";
export default {

    name: 'RequestDownloadModal',

    components: {
        Modal,
		Loader
    },

    data(){
        return {
            show:false,
			loading: false,
			email: ""
        }
    },

    methods: {
        open(){
            this.show=true;
        },

        close(){
            this.show=false
        },

        confirm() {

			this.loading = true;
			var temp = this;
			axios.post("/api/signin/user",{email:this.email,next:"/downloads/auto"}).then(function(response){

				temp.loading=false;

				var toastInstance = temp.$toasted.show('A signin link has been sent to your email', {
                    duration: "3000",
                    className: "toast-success",
                    position: "top-center"
                });
            	temp.close();

			}).catch(function(){

				temp.loading=false;
				var toastInstance = temp.$toasted.show('No account connected to email', {
                    duration: "3000",
                    className: "toast-danger",
                    position: "top-center"
                });
				temp.close();

			})


        }
    }

}
</script>
